import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-background-800 bg-primary-950">
      <div className="mx-auto w-full px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-leaf-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">
                激情丛林电影
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-400">
              专注电影《激情丛林》的剧情解析、专业影评与影视资讯。我们试图用更耐心的方式，陪你看懂这部电影里关于欲望、敬畏与选择的全部细节。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-information-line"></i>
              本站图片与内容均为演示素材，非真实版权信息。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-100">内容导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { label: "剧情介绍", to: "/plot" },
                { label: "影评中心", to: "/reviews" },
                { label: "资讯动态", to: "/news" },
                { label: "影片资料", to: "/about" },
                { label: "站内搜索", to: "/search" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-foreground-400 transition-colors hover:text-accent-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-100">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500"></i>
                contact@passionjungle-demo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-500"></i>
                影视内容演示站点
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-500"></i>
                每周一、三、五 更新
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-youtube-fill", "ri-bilibili-fill"].map((ic) => (
                <span
                  key={ic}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-800 text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
                  aria-label="社交媒体"
                >
                  <i className={`${ic} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 激情丛林电影 · 内容演示站点</p>
          <p>本站为演示项目，不提供播放、下载与支付服务</p>
        </div>
      </div>
    </footer>
  );
}